import {NotificationCenter} from "@vidazoo/ui-framework";
import { observer, inject } from "mobx-react";
export default inject("userNotificationsStore")(observer(NotificationCenter));
